import { API, Auth } from "aws-amplify";
import {
  isCorporateProfile,
  readActiveCorporateFacility,
} from "../../utils/corporateFacilityStorage";

export const getSpeak2Profile = async (throwOnError = false) => {
  const User = await Auth.currentAuthenticatedUser();
  const username = User.username;

  const RequestBody = {
    username: username,
  };
  try {
    let response = await API.post("lambda", "/users/profile/get", {
      body: RequestBody,
      response: true,
    });
    return response;
  } catch (error) {
    console.error("Error fetching Speak2 profile:", error);
    if (throwOnError) throw error;
    return null;
  }
};

// resolve facility context

export const resolveFacilityContext = async () => {
  const facilityContext = {
    facilityId: null,
    timezone: null,
    roleName: null,
    isCorporateUser: false,
    corporateId: null,
  };

  try {
    const res = await getSpeak2Profile();
    if (res?.data?.Success !== true) return facilityContext;

    const content = res.data.Content;
    const role0 = content?.Roles?.find((r) => Number(r?.IsActive) === 1) ?? content?.Roles?.[0];

    facilityContext.roleName = Number(role0?.IsActive) === 1 ? role0?.Name ?? null : null;
    facilityContext.isCorporateUser = isCorporateProfile(content);
    facilityContext.corporateId = content?.CorporateId ?? null;

    if (facilityContext.isCorporateUser) {
      const user = await Auth.currentAuthenticatedUser();
      const userId = user?.signInUserSession?.idToken?.payload?.sub;
      const active = readActiveCorporateFacility(userId);
      if (active?.facilityId) {
        facilityContext.facilityId = active.facilityId;
        facilityContext.timezone = active.timezone ?? null;
        return facilityContext;
      }
      return facilityContext;
    }

    facilityContext.facilityId = content?.Facility ?? null;
    facilityContext.timezone = content?.FacilityTimeZone ?? null;

    return facilityContext;
  } catch (e) {
    console.log("Error resolving facility context", e);
    return facilityContext;
  }
};
